import type { MouseEventHandler } from "react";
import { Button, Dropdown } from "react-bootstrap";
import messages from "messages";
// utils
import formatScheduleTitle from "../../utils/formatScheduleTitle";
import getClasses from "utils/getClasses";
// components
import IconButton from "components/icon-button";
import { ReactComponent as OutlineMenuVertical } from "assets/svg/outline-menu-vertical.svg";
// styles
import styles from "./Schedule.module.scss";
import { createPortal } from "react-dom";

type Props = {
  onClick: MouseEventHandler;
  onCopy: MouseEventHandler;
  onDelete: MouseEventHandler;
  active: boolean;
  order: number;
  timezone: TimeZone;
  value: Pick<ParsedAvailableTimePeriod, "start_date" | "end_date">;
  invalid?: boolean;
  className?: string;
};

/**
 * render schedule item block item in the left sidebar schedules list in edit availability modal
 */
const Schedule = ({
  onClick,
  onCopy,
  onDelete,
  active,
  order,
  timezone,
  value,
  invalid,
  className,
}: Props) => (
  <div
    onClick={onClick}
    tabIndex={0}
    className={getClasses(
      styles["schedule"],
      active && styles["schedule--active"],
      invalid && styles["schedule--invalid"],
      className,
    )}
  >
    {/* title row */}
    <div className={styles["schedule__header"]}>
      <span className={styles["schedule__title"]}>
        {`${messages.schedule} ${order}`}
      </span>
      <Dropdown onClick={(e) => e.stopPropagation()} drop={"end"}>
        <Dropdown.Toggle
          bsPrefix="p-0"
          as={IconButton}
          className={styles["schedule__actions-dropdown-toggle"]}
        >
          <OutlineMenuVertical />
        </Dropdown.Toggle>
        {createPortal(
          <Dropdown.Menu className={styles["schedule__actions-dropdown-menu"]}>
            <Dropdown.Item
              as={Button}
              variant={"link"}
              className={styles["schedule__actions-dropdown-action-item"]}
              onClick={onCopy}
            >
              {messages.duplicate}
            </Dropdown.Item>
            <Dropdown.Item
              as={Button}
              variant={"link"}
              className={styles["schedule__actions-dropdown-action-item"]}
              onClick={onDelete}
            >
              {messages.delete}
            </Dropdown.Item>
          </Dropdown.Menu>,
          document.body,
        )}
      </Dropdown>
    </div>
    <div className={styles["schedule__body"]}>
      {!value ? messages.newSchedule : formatScheduleTitle(value, timezone)}
    </div>
  </div>
);

export default Schedule;
